import React from 'react';
import FullscreenVideo from './fullscreenVideo.js';
import FullscreenImage from './fullscreenImage.js';
import FullscreenText from './fullscreenText.js';
import FullscreenStoreSliderBottomBar from './fullscreenStoreSliderBottomBar.js';
import { utils } from '../../utils';
import {versionManager} from '../../versioning/proGalleryVersionManager.js';


class FullscreenSlider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  isInDisplayRange(idx) {
    var range = (utils.isTouch()) ? 1 : 3;
    return (Math.abs(this.props.current.idx - idx) <= range);
  }

  prepareSlide(item) {

    var idx = item.idx;
    var inner;
    switch (item.type) {
      case 'video':
        inner = (
          <FullscreenVideo
            key={idx}
            item={item}
            isDisplayed={this.props.current.idx === idx}
            isDummy={!this.isInDisplayRange(idx)}
            window={this.props.window}
            styleParams={this.props.styleParams}
            actions={{
              toggleMobileBars: this.props.actions.toggleMobileBars
            }}

          />
        );
        break;
      case 'text':
        inner =
          <FullscreenText
            key={idx}
            item={item}
            isDummy={!this.isInDisplayRange(idx)}
            window={this.props.window}
          />;
        break;
      case 'image':
      case 'picture':
      default:
        inner = <FullscreenImage
          key={idx}
          item={item}
          isDummy={!this.isInDisplayRange(idx)}
          window={this.props.window}
        />;
    }
    return inner;
  }


  prepareSlides() {
    var slides = [];

    for (var i = 0; i < this.props.items.length; i++) {

      var animationType = utils.isTouch() ? 'swipe-' : 'fade-';

      var innerStyle = {
        width: this.props.window.size.width + 'px'
      };
      var transform = utils.browserIs('safari') ? 'none' : 'translate3d(0, 0, 0) scale(1)';

      if (utils.browserIs('safari') && !utils.isMobile()) {
        $.extend(innerStyle, {
          opacity: 1,
          transform: transform,
          'WebkitTransform': transform,
          'MozTransform': transform,
          'msTransform': transform,
          'OTransform': transform
        });
      } else {
        $.extend(innerStyle, {
          opacity: 1,
          willChange: 'transform',
        });
      }

      const itm = this.props.items[i];
      let slidePos = i;
      let isCurrent = false;
      let slideClasses = ['slide'];

      switch (slidePos - this.props.current.pos) {
        case 0:
          slideClasses.push(animationType + 'current current-slide fullscreen-current');
          isCurrent = true;
          break;
        case 1:
          slideClasses.push(animationType + 'adjacent next-slide');
          break;
        case -1:
          slideClasses.push(animationType + 'adjacent prev-slide');
          break;
        default:
          slideClasses.push(animationType + 'far-away');
      }

      if (this.props.animating) {

        slideClasses.push(animationType + 'animated');

        switch (slidePos - this.props.current.pos) {
          case 0:
            slideClasses.push(animationType + 'animated-current');
            break;
          case 1:
            if (this.props.direction == 1) {
              slideClasses.push(animationType + 'animated-next');
            }
            break;
          case -1:
            if (this.props.direction == -1) {
              slideClasses.push(animationType + 'animated-prev');
            }
            break;
        }
        ;
      }
      // console.log("Pushing item Pushing item #" + itm.idx, itm);

      slides.push(
        (itm && itm.idx >= 0) ? (
          <div key={"swipe-item-" + itm.idx} data-index={itm.idx}
               className={slideClasses.join(' ')}
               style={innerStyle}
               data-hook={isCurrent ? "fullscreen-current" : "fullscreen-away"}
          >
            {this.prepareSlide(itm)}
          </div>
        ) : (
          <div key={"swipe-item-placeholder-" + slidePos}
               className={slideClasses.join(' ')}
               style={innerStyle}
          />
        )
      );
    }

    return slides;
  }

  getLeftArrowSvg() {
    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" stroke="none" width="15" height="27" viewBox="0 0 15 27">
              <g fillRule="evenodd">
                  <path fillRule="nonzero" d="M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z"/>
              </g>
          </svg>
  }

  getRightArrowSvg() {
    return <svg fill="currentColor" stroke="none" width="15" height="27" viewBox="0 0 15 27">
              <g fillRule="evenodd">
                  <path fillRule="nonzero" d="M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z"/>
              </g>
          </svg>
  }

  render() {
    var firstSlidePosition = this.props.current.pos * this.props.window.size.width;
    let shouldShowStoreArrows = versionManager.useFullscreenNewSlider() && !utils.isSmallScreen()

    var leftArrowLeftPos = firstSlidePosition + ((this.props.window.expanded && versionManager.useFullscreenNewSlider()) ? 10 : 0);
    var rightArrowLeftPos = firstSlidePosition + (this.props.window.size.width - ((this.props.window.expanded && versionManager.useFullscreenNewSlider()) ? 110 : 100));
    var transform = 'translate3d(0, 0, 0) scale(1)';
    return (
      <div id='slider' className='swipe'>
        <div className={'swipe-wrap before-swipe swipe-wrap-idx-' + this.props.current.idx}
             key={'swipe-wrap'}
             style={{
               width: ((this.props.current.pos * 2 + 1) * this.props.window.size.width),
               marginLeft: (-1 * firstSlidePosition),
               willChange: 'transform',
             }}
        >
          {shouldShowStoreArrows ? (<button className={"arrow arrow-left fullscreen-icon " + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : '')}
          onClick={() => this.props.actions.fadeToNextSlide(-1)}
          tabIndex={this.props.current.idx <= 0 ? -1 : utils.getTabIndex('fullscreenPrev')}
          aria-label='Previous Item'
          style={{
            left: leftArrowLeftPos,
          }}>
            {this.getLeftArrowSvg()}
          </button>) : ''};
          {this.prepareSlides()}
          {shouldShowStoreArrows ? (<button className={"arrow arrow-right fullscreen-icon" + (this.props.current.idx >= (this.props.totalItems - 1) ? ' fullscreen-icon-disabled ' : '')}
          onClick={() => this.props.actions.fadeToNextSlide(1)}
          tabIndex={this.props.current.idx >= (this.props.totalItems - 1) ? -1 : utils.getTabIndex('fullscreenNext')}
          aria-label='Next Item'
          style={{
            left: rightArrowLeftPos,
          }}>
            {this.getRightArrowSvg()}
          </button>) : ''};
      </div>
    </div>
    );
  }
}

export default FullscreenSlider;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenSlider.js